import { FloatingWindow } from '@design-system/components/floatingWindow/floatingWindow';
import { Modal } from '@design-system/components/modal/modal';
import { createPortal } from 'react-dom';
import { DropZone } from '@design-system/components/dropZone/dropZone';
import { sprinkles } from '@design-system/sprinkles.css';
import { UpladCta } from './UploadCta';
import { UploadList } from './UploadList';
import { ConfirmationModal } from './ConfirmationModal';
import { useUploadVideoVM } from '../../view-models/uploadVideo.viewModel';
import { useToastEffect } from '@client/new/helpers/useNotifcations';
import { allowedVideoTypes } from '../../constants';

export const VideoUploadStateModal = () => {
  const {
    dispatch,
    list,
    modal,
    floatingWindow,
    confirmationModal,
    notifications,
  } = useUploadVideoVM();
  useToastEffect(notifications);

  return (
    <>
      {createPortal(
        <>
          <FloatingWindow
            {...floatingWindow}
            toggle={() => dispatch('toggle')}
          />
          <Modal
            isOpen={modal.open}
            onClose={() => dispatch('closeModal')}
            title="Upload Files"
            customCloseIcon={modal.customCloseIcon}
            disableBackdropClick={true}
          >
            <div
              className={sprinkles({
                display: 'flex',
                flexDirection: 'column',
                gap: 'xl',
              })}
            >
              {modal.showDropZone ? (
                <DropZone
                  onChange={(files: File[]) => dispatch('onDrop', files)}
                  accept={allowedVideoTypes}
                  multiple={true}
                  className="h-[170px]"
                />
              ) : null}
              <UploadList {...list} dispatch={dispatch} />
              <UpladCta
                dispatch={dispatch}
                showUpload={modal.uploadButton.show}
                uploadDisabled={modal.uploadButton.disabled}
              />
            </div>
          </Modal>
          <ConfirmationModal
            isOpen={confirmationModal.open}
            onClose={() => dispatch('closeConfirmation')}
            onConfirm={() => dispatch('confirmCancel')}
          />
        </>,
        document.body,
      )}
    </>
  );
};
